module.exports = __webpack_public_path__ + "static/other/librarian.c5aad305.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/librarian.json
// module id = 2529
// module chunks = 0